import { RingProgress } from "@ant-design/plots";
import React from "react";

interface Props {
  percent: number;
}

const ProgressChart = ({ percent = 0 }: Props) => {
  const config = {
    height: 250,
    width: 250,
    autoFit: true,
    percent: percent / 100,
    // percent: 0.6,
    color: ["#F4664A", "#E8EDF3"],
    innerRadius: 0.65,
    radius: 0.98,

    // statistic: {
    //   title: {
    //     style: {
    //       color: "#363636",
    //       fontSize: "20px",
    //       // lineHeight: "14px",
    //     },
    //     formatter: () => "进度",
    //   },
    // },
  };
  return <RingProgress {...config} />;
};

export default ProgressChart;
